import React, { useState, useEffect } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu } from 'reactstrap';
import { Link, NavLink, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { logoutUserFromFirebase } from 'Store/Actions';
import IntlMessages from 'Util/IntlMessages';

const userBlockStyles = `
  /* Scoped, high-specificity styles prevent legacy theme rules from washing out this menu. */
  .top-sidebar .sidebar-user-block .rct-dropdown .user-block-toggle {
    box-sizing: border-box !important;
    width: 100% !important;
    min-width: 0 !important;
    display: flex !important;
    align-items: center !important;
    padding: 9px 10px !important;
    border: 1px solid transparent !important;
    border-radius: 14px !important;
    background: transparent !important;
    color: #263b70 !important;
    text-align: left !important;
    opacity: 1 !important;
    cursor: pointer !important;
    transition: background-color 160ms ease, border-color 160ms ease, box-shadow 160ms ease;
  }

  .top-sidebar .sidebar-user-block .rct-dropdown .user-block-toggle:hover,
  .top-sidebar .sidebar-user-block .rct-dropdown .user-block-toggle[aria-expanded='true'] {
    background: #f5f7ff !important;
    border-color: #e5ebff !important;
  }

  .top-sidebar .sidebar-user-block .rct-dropdown .user-block-toggle:focus-visible {
    outline: 3px solid rgba(48, 83, 255, 0.22) !important;
    outline-offset: 2px !important;
  }

  .top-sidebar .sidebar-user-block .user-profile {
    position: relative !important;
    flex: 0 0 44px !important;
    width: 44px !important;
    height: 44px !important;
  }

  .top-sidebar .sidebar-user-block .user-profile::after {
    content: '';
    position: absolute;
    right: 0;
    bottom: 0;
    width: 11px;
    height: 11px;
    border: 2px solid #fff;
    border-radius: 50%;
    background: #22c55e;
  }

  .top-sidebar .sidebar-user-block .user-block-avatar,
  .top-sidebar .sidebar-user-block .user-block-avatar-fallback {
    box-sizing: border-box !important;
    width: 44px !important;
    height: 44px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    border: 2px solid #fff !important;
    border-radius: 50% !important;
    box-shadow: 0 2px 8px rgba(37, 71, 160, 0.13) !important;
    object-fit: cover !important;
  }

  .top-sidebar .sidebar-user-block .user-block-avatar-fallback {
    background: linear-gradient(135deg, #4367ff 0%, #243cf4 100%) !important;
    color: #fff !important;
    font-size: 16px !important;
    font-weight: 700 !important;
  }

  .top-sidebar .sidebar-user-block .user-info {
    min-width: 0 !important;
    flex: 1 1 auto !important;
    margin-left: 11px !important;
  }

  .top-sidebar .sidebar-user-block .user-name {
    display: block !important;
    overflow: hidden !important;
    color: #263b70 !important;
    font-size: 0.88rem !important;
    font-weight: 700 !important;
    line-height: 1.35 !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
    opacity: 1 !important;
  }

  .top-sidebar .sidebar-user-block .user-email {
    display: block !important;
    max-width: 100% !important;
    overflow: hidden !important;
    margin-top: 2px !important;
    color: #8091b2 !important;
    font-size: 0.72rem !important;
    font-weight: 500 !important;
    line-height: 1.35 !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
    opacity: 1 !important;
  }

  .top-sidebar .sidebar-user-block .dropdown-icon {
    flex: 0 0 auto !important;
    margin-left: 8px !important;
    color: #8192b4 !important;
    font-size: 17px !important;
    transition: transform 160ms ease, color 160ms ease;
  }

  .top-sidebar .sidebar-user-block .user-block-toggle[aria-expanded='true'] .dropdown-icon {
    color: #3157f6 !important;
    transform: rotate(180deg);
  }

  .top-sidebar .sidebar-user-block .rct-dropdown .dropdown-menu.user-block-dropdown-menu {
    box-sizing: border-box !important;
    width: 210px !important;
    min-width: 200px !important;
    max-width: calc(100vw - 24px) !important;
    margin-top: 7px !important;
    padding: 8px !important;
    overflow: hidden !important;
    border: 1px solid #e5ecf8 !important;
    border-radius: 16px !important;
    background: #fff !important;
    color: #536585 !important;
    box-shadow: 0 14px 34px rgba(36, 59, 112, 0.16), 0 3px 9px rgba(36, 59, 112, 0.05) !important;
    opacity: 1 !important;
    filter: none !important;
    z-index: 1080 !important;
  }

  .top-sidebar .sidebar-user-block .user-block-dropdown-menu .user-menu-header {
    box-sizing: border-box !important;
    display: flex !important;
    align-items: center !important;
    width: 100% !important;
    min-width: 0 !important;
    margin: 0 0 6px !important;
    padding: 10px !important;
    border: 1px solid #e5ebff !important;
    border-radius: 11px !important;
    background: #f4f7ff !important;
    color: #263b70 !important;
    opacity: 1 !important;
    filter: none !important;
  }

  .top-sidebar .sidebar-user-block .user-block-dropdown-menu .user-menu-header-avatar {
    box-sizing: border-box !important;
    flex: 0 0 42px !important;
    width: 42px !important;
    height: 42px !important;
    margin: 0 10px 0 0 !important;
    border: 2px solid #fff !important;
    border-radius: 50% !important;
    box-shadow: 0 2px 8px rgba(37, 71, 160, 0.12) !important;
    object-fit: cover !important;
  }

  .top-sidebar .sidebar-user-block .user-block-dropdown-menu .user-menu-header-avatar.user-block-avatar-fallback {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    background: #e2eaff !important;
    color: #3157f6 !important;
    font-size: 15px !important;
    font-weight: 700 !important;
    box-shadow: none !important;
  }

  .top-sidebar .sidebar-user-block .user-block-dropdown-menu .user-menu-header-copy {
    min-width: 0 !important;
    flex: 1 1 auto !important;
  }

  .top-sidebar .sidebar-user-block .user-block-dropdown-menu .user-menu-eyebrow {
    display: block !important;
    margin: 0 0 3px !important;
    color: #8292b1 !important;
    font-size: 9px !important;
    font-weight: 800 !important;
    letter-spacing: 0.09em !important;
    line-height: 1.2 !important;
    text-transform: uppercase !important;
    opacity: 1 !important;
  }

  .top-sidebar .sidebar-user-block .user-block-dropdown-menu .user-menu-header-name {
    display: block !important;
    overflow: hidden !important;
    margin: 0 !important;
    color: #263b70 !important;
    font-size: 13px !important;
    font-weight: 700 !important;
    line-height: 1.35 !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
    opacity: 1 !important;
  }

  .top-sidebar .sidebar-user-block .user-block-dropdown-menu .user-menu-header-email {
    display: block !important;
    overflow: hidden !important;
    margin: 3px 0 0 !important;
    color: #7082a5 !important;
    font-size: 11px !important;
    font-weight: 500 !important;
    line-height: 1.35 !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
    opacity: 1 !important;
  }

  .top-sidebar .sidebar-user-block .user-block-dropdown-menu .user-menu-list {
    display: block !important;
    margin: 0 !important;
    padding: 0 !important;
    list-style: none !important;
    background: #fff !important;
  }

  .top-sidebar .sidebar-user-block .user-block-dropdown-menu .user-menu-list > li {
    display: block !important;
    margin: 0 !important;
    padding: 0 !important;
    border: 0 !important;
    background: transparent !important;
    list-style: none !important;
  }

  .top-sidebar .sidebar-user-block .user-block-dropdown-menu a.user-menu-item,
  .top-sidebar .sidebar-user-block .user-block-dropdown-menu button.user-menu-item {
    box-sizing: border-box !important;
    display: flex !important;
    align-items: center !important;
    width: 100% !important;
    height: 40px !important;
    min-height: 40px !important;
    margin: 1px 0 !important;
    padding: 4px 8px !important;
    border: 0 !important;
    border-radius: 9px !important;
    background: transparent !important;
    color: #536585 !important;
    font-family: inherit !important;
    font-size: 12.5px !important;
    font-weight: 600 !important;
    line-height: 1.3 !important;
    text-align: left !important;
    text-decoration: none !important;
    text-transform: none !important;
    white-space: nowrap !important;
    opacity: 1 !important;
    box-shadow: none !important;
    cursor: pointer !important;
    transition: color 150ms ease, background-color 150ms ease;
  }

  .top-sidebar .sidebar-user-block .user-block-dropdown-menu a.user-menu-item:hover,
  .top-sidebar .sidebar-user-block .user-block-dropdown-menu button.user-menu-item:hover,
  .top-sidebar .sidebar-user-block .user-block-dropdown-menu a.user-menu-item:focus-visible,
  .top-sidebar .sidebar-user-block .user-block-dropdown-menu button.user-menu-item:focus-visible {
    background: #f2f5ff !important;
    color: #2d50e8 !important;
    outline: none !important;
  }

  .top-sidebar .sidebar-user-block .user-block-dropdown-menu a.user-menu-item:focus-visible,
  .top-sidebar .sidebar-user-block .user-block-dropdown-menu button.user-menu-item:focus-visible {
    box-shadow: inset 0 0 0 2px rgba(49, 87, 246, 0.2) !important;
  }

  .top-sidebar .sidebar-user-block .user-block-dropdown-menu a.user-menu-item.is-active {
    background: #edf2ff !important;
    color: #2e50ed !important;
  }

  .top-sidebar .sidebar-user-block .user-block-dropdown-menu .user-menu-item-label {
    display: block !important;
    min-width: 0 !important;
    flex: 1 1 auto !important;
    overflow: hidden !important;
    color: inherit !important;
    font-size: inherit !important;
    font-weight: inherit !important;
    line-height: inherit !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
    opacity: 1 !important;
  }

  .top-sidebar .sidebar-user-block .user-block-dropdown-menu .user-menu-item-icon {
    box-sizing: border-box !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    flex: 0 0 28px !important;
    width: 28px !important;
    height: 28px !important;
    margin: 0 9px 0 0 !important;
    padding: 0 !important;
    border: 0 !important;
    border-radius: 8px !important;
    background: #edf2ff !important;
    color: #3157f6 !important;
    font-size: 14px !important;
    line-height: 1 !important;
    opacity: 1 !important;
  }

  .top-sidebar .sidebar-user-block .user-block-dropdown-menu .user-menu-item-icon i,
  .top-sidebar .sidebar-user-block .user-block-dropdown-menu .user-menu-item-chevron {
    color: #3157f6 !important;
    opacity: 1 !important;
    font-size: 14px !important;
    line-height: 1 !important;
  }

  .top-sidebar .sidebar-user-block .user-block-dropdown-menu .user-menu-item-chevron {
    flex: 0 0 auto !important;
    margin-left: 6px !important;
    color: #9aa8c1 !important;
    opacity: 0 !important;
  }

  .top-sidebar .sidebar-user-block .user-block-dropdown-menu a.user-menu-item:hover .user-menu-item-chevron,
  .top-sidebar .sidebar-user-block .user-block-dropdown-menu a.user-menu-item:focus-visible .user-menu-item-chevron,
  .top-sidebar .sidebar-user-block .user-block-dropdown-menu a.user-menu-item.is-active .user-menu-item-chevron {
    opacity: 1 !important;
  }

  .top-sidebar .sidebar-user-block .user-block-dropdown-menu .user-menu-list > li.user-menu-divider {
    display: block !important;
    height: 1px !important;
    margin: 6px 4px !important;
    padding: 0 !important;
    border: 0 !important;
    background: #edf1f8 !important;
  }

  .top-sidebar .sidebar-user-block .user-block-dropdown-menu button.user-menu-item--logout,
  .top-sidebar .sidebar-user-block .user-block-dropdown-menu button.user-menu-item--logout .user-menu-item-label {
    color: #bd4755 !important;
  }

  .top-sidebar .sidebar-user-block .user-block-dropdown-menu button.user-menu-item--logout .user-menu-item-icon {
    background: #fff0f1 !important;
    color: #d44858 !important;
  }

  .top-sidebar .sidebar-user-block .user-block-dropdown-menu button.user-menu-item--logout .user-menu-item-icon i {
    color: #d44858 !important;
  }

  .top-sidebar .sidebar-user-block .user-block-dropdown-menu button.user-menu-item--logout:hover,
  .top-sidebar .sidebar-user-block .user-block-dropdown-menu button.user-menu-item--logout:focus-visible {
    background: #fff3f4 !important;
    color: #bd3343 !important;
  }

  .top-sidebar .sidebar-user-block .user-block-dropdown-menu button.user-menu-item--logout:hover .user-menu-item-icon,
  .top-sidebar .sidebar-user-block .user-block-dropdown-menu button.user-menu-item--logout:focus-visible .user-menu-item-icon {
    background: #ffe5e8 !important;
  }

  @media (max-width: 420px) {
    .top-sidebar .sidebar-user-block .rct-dropdown .dropdown-menu.user-block-dropdown-menu {
      width: min(260px, calc(100vw - 24px)) !important;
      min-width: min(230px, calc(100vw - 24px)) !important;
    }
  }
`

// Links displayed inside the user-profile dropdown, beneath User Profile.
const PROFILE_MENU_LINKS = [
  {
    path: '/app/dashboard/liability-dashboard',
    label: 'Liability Tracker',
    icon: 'zmdi zmdi-assignment',
  },
  {
    path: '/app/dashboard/company-profile',
    label: 'Company Profile',
    icon: 'zmdi zmdi-city-alt',
  },
  {
    path: '/app/dashboard/quick-actions',
    label: 'Quick Actions',
    icon: 'zmdi zmdi-flash',
  },
  {
    path: '/app/dashboard/subcompanies-management',
    label: 'Manage Subcompanies',
    icon: 'zmdi zmdi-accounts-alt',
  },
];

const getInitials = (name) => {
  const parts = (name || '').trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return 'U';
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  return `${parts[0].charAt(0)}${parts[parts.length - 1].charAt(0)}`.toUpperCase();
};

const resolveProfilePictureUrl = (pictureUrl) => {
  if (!pictureUrl || typeof pictureUrl !== 'string') return null;

  let resolvedUrl = pictureUrl.trim();
  if (!resolvedUrl) return null;

  if (!/^https?:\/\//i.test(resolvedUrl)) {
    const configuredBaseUrl = process.env.REACT_APP_BASE_URL || 'http://localhost:5228/api/';
    const baseUrl = configuredBaseUrl.replace(/\/api\/?$/i, '').replace(/\/$/, '');
    resolvedUrl = resolvedUrl.startsWith('/')
      ? `${baseUrl}${resolvedUrl}`
      : `${baseUrl}/${resolvedUrl}`;
  }

  const separator = resolvedUrl.includes('?') ? '&' : '?';
  return `${resolvedUrl}${separator}t=${Date.now()}`;
};

function UserBlock() {
  const [userDropdownMenu, setUserDropdownMenu] = useState(false);
  const [fullName, setFullName] = useState('User');
  const [email, setEmail] = useState('');
  const [profilePicture, setProfilePicture] = useState(null);
  const [initials, setInitials] = useState('U');

  const dispatch = useDispatch();
  const history = useHistory();
  const userState = useSelector((state) => state.user || {});
  const users = Array.isArray(userState.users) ? userState.users : [];
  const currentUserId = localStorage.getItem('userId');
  const currentUser = users.find((user) => {
    const userId = user.userId || user.id || user.UserId || user.ID;
    return String(userId) === String(currentUserId);
  });

  // Keep the same access rule as the existing sidebar dropdown.
  const isSuperUser = localStorage.getItem('access') === 'superUser';

  // Manage Subcompanies is available only in the parent-company session.
  const parentCompanyId = localStorage.getItem('companyId');
  const selectedCompanyId = localStorage.getItem('selectedCompanyId');
  const isSubCompanySession = Boolean(parentCompanyId)
    && Boolean(selectedCompanyId)
    && selectedCompanyId !== parentCompanyId;

  useEffect(() => {
    const styleTag = document.createElement('style');
    styleTag.id = 'user-block-dropdown-styles';
    styleTag.textContent = userBlockStyles;
    document.head.appendChild(styleTag);

    return () => {
      if (styleTag.parentNode) styleTag.parentNode.removeChild(styleTag);
    };
  }, []);

  useEffect(() => {
    const storedFullName = localStorage.getItem('name') || 'User';
    const storedEmail = localStorage.getItem('user_email') || '';
    const candidatePicture = currentUser && (
      currentUser.profilePictureUrl
      || currentUser.profilePicUrl
      || currentUser.profilePicture
      || currentUser.profilePic
    );
    const storedPicture = localStorage.getItem('profilePictureUrl');

    setFullName(storedFullName);
    setEmail(storedEmail);
    setInitials(getInitials(storedFullName));
    setProfilePicture(resolveProfilePictureUrl(candidatePicture || storedPicture));
  // `users` changes when Redux receives updated user data.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userState.users]);

  const logoutUser = async (event) => {
    event.preventDefault();
    setUserDropdownMenu(false);

    try {
      // Keep the existing logout action and redirect behavior.
      await dispatch(logoutUserFromFirebase(history));
    } catch (error) {
      console.warn('Logout action failed; redirecting to sign-in.', error);
      history.replace('/signin');
    }
  };

  const toggleUserDropdownMenu = () => {
    setUserDropdownMenu((isOpen) => !isOpen);
  };

  const handleToggleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      toggleUserDropdownMenu();
    }
  };

  const renderAvatar = (additionalClassName = '') => (
    profilePicture ? (
      <img
        src={profilePicture}
        alt=""
        className={`user-block-avatar ${additionalClassName}`.trim()}
        onError={() => setProfilePicture(null)}
      />
    ) : (
      <div
        className={`user-block-avatar-fallback ${additionalClassName}`.trim()}
        aria-hidden="true"
      >
        {initials}
      </div>
    )
  );

  const visibleProfileLinks = isSuperUser
    ? PROFILE_MENU_LINKS.filter(
      (item) => item.path !== '/app/dashboard/subcompanies-management' || !isSubCompanySession,
    )
    : [];

  return (
    <div className="top-sidebar">
      <div className="sidebar-user-block">
        <Dropdown
          isOpen={userDropdownMenu}
          toggle={toggleUserDropdownMenu}
          className="rct-dropdown"
        >
          <DropdownToggle
            tag="div"
            className="user-block-toggle"
            role="button"
            tabIndex={0}
            aria-haspopup="menu"
            aria-expanded={userDropdownMenu}
            aria-label="Open user profile menu"
            onKeyDown={handleToggleKeyDown}
          >
            <div className="user-profile">
              {renderAvatar()}
            </div>
            <div className="user-info">
              <span className="user-name">{fullName}</span>
              <span className="user-email">{email}</span>
            </div>
            <i className="zmdi zmdi-chevron-down dropdown-icon" aria-hidden="true" />
          </DropdownToggle>

          <DropdownMenu right className="user-block-dropdown-menu" aria-label="User profile menu">
            <div className="user-menu-header">
              {renderAvatar('user-menu-header-avatar')}
              <div className="user-menu-header-copy">
                <span className="user-menu-eyebrow">Signed in as</span>
                <span className="user-menu-header-name" title={fullName}>{fullName}</span>
                <span className="user-menu-header-email" title={email}>{email}</span>
              </div>
            </div>

            <ul className="user-menu-list">
              <li>
                <Link
                  to={{ pathname: '/app/dashboard/user-profile', state: { activeTab: 0 } }}
                  className="user-menu-item"
                  onClick={() => setUserDropdownMenu(false)}
                >
                  <span className="user-menu-item-icon"><i className="zmdi zmdi-account user-menu-icon-glyph" aria-hidden="true" /></span>
                  <span className="user-menu-item-label"><IntlMessages id="widgets.profile" /></span>
                  <i className="zmdi zmdi-chevron-right user-menu-item-chevron" aria-hidden="true" />
                </Link>
              </li>

              {visibleProfileLinks.map((item) => (
                <li key={item.path}>
                  <NavLink
                    to={item.path}
                    activeClassName="is-active"
                    className="user-menu-item"
                    onClick={() => setUserDropdownMenu(false)}
                  >
                    <span className="user-menu-item-icon"><i className={`${item.icon} user-menu-icon-glyph`} aria-hidden="true" /></span>
                    <span className="user-menu-item-label">{item.label}</span>
                    <i className="zmdi zmdi-chevron-right user-menu-item-chevron" aria-hidden="true" />
                  </NavLink>
                </li>
              ))}

              <li className="user-menu-divider" role="separator" />
              <li>
                <button
                  type="button"
                  className="user-menu-item"
                  onClick={logoutUser}
                >
                  <span className="user-menu-item-icon"><i className="zmdi zmdi-power user-menu-icon-glyph" aria-hidden="true" /></span>
                  <span className="user-menu-item-label">Logout</span>
                </button>
              </li>
            </ul>
          </DropdownMenu>
        </Dropdown>
      </div>
    </div>
  );
}

export default UserBlock;
